import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCurrentUser } from "./redux/rolesSagas";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { PopupFilters } from "./smartComponents/PopupFilters";
import { Delete } from "./smartComponents/Delete";
// import { Trash } from "../../../../assets/images/svg";
import "./roles.scss";

export function RolesModule({ params }) {
  const dispatch = useDispatch();
  const { isLoading, roles } = useSelector((state) => state.roles);

  const [popup, setPopup] = useState({
    popupFilter: false,
    delete: false,
    preview: false
  });

  const openPopup = (type) => {
    setPopup((prev) => ({ ...prev, [type]: true }));
  };

  const closePopup = (type) => {
    return () => setPopup((prev) => ({ ...prev, [type]: false }));
  };

  useEffect(() => {
    dispatch(fetchCurrentUser(params));
  }, []);

  if (isLoading)
    return (
      <div className="light">
        <LoadingAnimation />
      </div>
    );

  return (
    <div className="roles">
      <div className="roles__add">
        <button onClick={() => openPopup("popupFilter")} className="add-button">
          Add New Role
        </button>
      </div>

      <div className="roles__content">
        <ul className="group">
          {Object.keys(roles).map((role, index) => {
            return (
              <>
                <div style={{ fontWeight: "bold", marginBottom: 10 }} key={role}>
                  {role}
                </div>
                {roles[role].map(({ name, id, organization_id }) => {
                  return (
                    <li color="dark" className="group__item" key={id}>
                      <div className="group__item__el text">{name}</div>

                      {/* <div className="group__item__el delete">
                        <span
                          className="roles__icon"
                          onClick={() =>
                            handlePopup(
                              { roleId: id, organization: { name: role, id: organization_id } },
                              "delete"
                            )
                          }
                          title="Delete"
                        >
                          <Trash />
                        </span>
                      </div> */}
                    </li>
                  );
                })}
              </>
            );
          })}
        </ul>
      </div>

      <PopupFilters isOpen={popup.popupFilter} onClose={closePopup("popupFilter")} />

      <Delete isOpen={popup.delete} onClose={closePopup("delete")} />
    </div>
  );
}
